var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20611_24679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 42.5V4.914L39.293 19.207L40.707 17.793L24 1.086L7.293 17.793L8.707 19.207L23 4.914V42.5H25Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 40.5C46 43.809 43.309 46.5 40 46.5H8C4.691 46.5 2 43.809 2 40.5V35.5H0V40.5C0 44.911 3.589 48.5 8 48.5H40C44.411 48.5 48 44.911 48 40.5V35.5H46V40.5Z",
    fill: "#031434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20611_24679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrowIcon);
export default __webpack_public_path__ + "static/media/upload_arrow_icon.492e56579b8bcb2b74b8077babfea56e.svg";
export { ForwardRef as ReactComponent };